import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { getSocialLink, updateSocialLink } from "store/actions";
import Loader from "components/shared/Loader";
import ImageUpdate from "components/shared/ImageUpdate";

const EditService = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [selectedImage, setSelectedImage] = useState({
    preview: "",
    path: "",
  });

  const { socialLink, loading } = useSelector((state) => state?.socialLinks);

  useEffect(() => {
    dispatch(getSocialLink({ id }));
  }, [dispatch, id]);

  useEffect(() => {
    reset({
      link: socialLink?.link,
    });

    setSelectedImage({
      preview: socialLink?.icon,
      path: socialLink?.icon,
    });
  }, [socialLink, reset]);

  const onSubmit = (data) => {
    data.icon = selectedImage.path;

    dispatch(
      updateSocialLink({
        data,
        id,
        navigate,
        toast,
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card card-client">
          <div className="card-head">
            <h4>تعديل البيانات</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5> ايقون التواصل</h5>
                      <ImageUpdate
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                      />
                      {!selectedImage.path && (
                        <p className="error-hint">يرجي اختيار الايقونة</p>
                      )}
                    </div>
                  </Col>
                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>رابط التواصل</h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="رابط التواصل"
                          {...register("link", { required: true })}
                        />
                      </div>
                      <p className="error-hint">
                        {errors?.link && "يرجي ادخال رابط التواصل"}
                      </p>
                    </div>
                  </Col>

                  <Col lg={4} xs={12}>
                    <div className="form-group">
                      <button type="submit" className="btn btn-blue">
                        حفظ
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditService;
